module.exports = __webpack_public_path__ + "img/student.e9940da0.png";